import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const COLORS = {
    Complete: '#10b981',
    Running: '#3b82f6',
    Failed: '#ef4444',
    Skipped: '#a1a1aa'
};

function StatusDonutChart({ runs, compact = false, onStatusClick = null, selectedStatus = '' }) {
    const statusCounts = runs.reduce((acc, run) => {
        acc[run.status] = (acc[run.status] || 0) + 1;
        return acc;
    }, {});

    const data = Object.entries(statusCounts).map(([name, value]) => ({
        name,
        value
    }));

    if (data.length === 0) {
        return <div className="chart-empty">No data available</div>;
    }

    const handleClick = (data) => {
        if (onStatusClick && data && data.name) {
            onStatusClick(data.name);
        }
    };

    return (
        <div className={`chart-container ${compact ? 'compact' : ''}`}>
            {!compact && <h3 className="chart-title">Status Breakdown</h3>}
            <ResponsiveContainer width="100%" height={compact ? 200 : 300}>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={compact ? 40 : 60}
                        outerRadius={compact ? 70 : 100}
                        paddingAngle={2}
                        dataKey="value"
                        label={!compact}
                        onClick={handleClick}
                        style={{ cursor: onStatusClick ? 'pointer' : 'default' }}
                    >
                        {data.map((entry, index) => (
                            <Cell 
                                key={`cell-${index}`} 
                                fill={COLORS[entry.name] || '#6366f1'} 
                                opacity={selectedStatus && selectedStatus !== entry.name ? 0.3 : 1}
                                stroke={selectedStatus === entry.name ? '#fff' : 'none'}
                                strokeWidth={selectedStatus === entry.name ? 2 : 0}
                            />
                        ))}
                    </Pie>
                    <Tooltip 
                        contentStyle={{ 
                            background: 'rgba(26, 26, 46, 0.95)', 
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '8px',
                            color: '#e4e4e7'
                        }}
                    />
                    <Legend 
                        wrapperStyle={{ color: '#e4e4e7' }}
                        formatter={(value) => <span style={{ color: '#e4e4e7' }}>{value}</span>}
                        onClick={(e) => onStatusClick && onStatusClick(e.value)}
                    />
                </PieChart>
            </ResponsiveContainer>
            {onStatusClick && (
                <p className="chart-click-hint">Click a segment to filter</p>
            )}
        </div>
    );
}

export default StatusDonutChart;
